import { IGlobalProductEntity, PRODUCT_NAMES } from "components/BusinessToolForm/Sections/Global/general/products";

export const getProductsProductionData = (products: IGlobalProductEntity[]) => {
  return products.map((product) => {
    return {
      [PRODUCT_NAMES.PRODUCT_ID]: product[PRODUCT_NAMES.PRODUCT_ID],
      [PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL]: product[PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL],
      [PRODUCT_NAMES.ANNUAL_SALES_GROWTH_RATE]: product[PRODUCT_NAMES.ANNUAL_SALES_GROWTH_RATE],
    };
  });
};

export const getProductsProductionParams = (products: IGlobalProductEntity[]) => {
  return products.map((product) => {
    return {
      [PRODUCT_NAMES.PRODUCT_ID]: product[PRODUCT_NAMES.PRODUCT_ID] ?? '',
      productionVolume: Number(product[PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL]),
      annualGrowthRate: Number(product[PRODUCT_NAMES.ANNUAL_SALES_GROWTH_RATE]),
    };
  })
};
